const copyWithFallback = (url) => {
    const textArea = document.createElement('textarea');

    textArea.value = url;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();

    const copied = document.execCommand('copy');

    textArea.remove();

    return copied;
};

const copyPostLink = () => {
    document.addEventListener('click', async (event) => {
        const button = event.target.closest('.bn-sara__icon--copy');

        if (!button) {
            return;
        }

        const url = button.dataset.copyUrl;

        if (!url) {
            return;
        }

        try {
            if (navigator.clipboard?.writeText && window.isSecureContext) {
                await navigator.clipboard.writeText(url);
            } else if (!copyWithFallback(url)) {
                return;
            }
        } catch {
            return;
        }

        const copiedLabel = button.dataset.copiedLabel || 'Copied';
        const tooltip = button.querySelector('.bn-sara__copy-tooltip');

        button.dataset.copied = 'true';
        tooltip.textContent = copiedLabel;

        window.clearTimeout(button.copyFeedbackTimeout);
        button.copyFeedbackTimeout = window.setTimeout(() => {
            delete button.dataset.copied;
            tooltip.textContent = '';
        }, 2000);
    });
};

module.exports = { copyPostLink };